// src/utils/models/purchaseInvoiceModel.js
// Factura de COMPRA (recibida de proveedor o comercial)
// También se usa para ABONOS: el cliente es el emisor y EPC el receptor.

export const PURCHASE_INVOICE_STATUS = {
  UNPAID: "unpaid",
  PAID: "paid",
};

export const PURCHASE_INVOICE_STATUS_LABELS = {
  unpaid: "Sin pagar",
  paid: "Pagada",
};

export const PAYMENT_METHODS = {
  TRANSFER: "transfer",
  CASH: "cash",
};

export const PAYMENT_METHOD_LABELS = {
  transfer: "Transferencia",
  cash: "Al contado",
};

// Tipo de emisor de la factura
export const EMITTER_TYPES = {
  SUPPLIER: "supplier",
  COMMERCIAL: "commercial",
  CLIENT: "client",
};

export const EMITTER_TYPE_LABELS = {
  supplier: "Proveedor",
  commercial: "Comercial",
  client: "Cliente",
};

export const createPurchaseInvoice = (data) => ({
  id: "",

  // Número de factura
  invoiceNumber: data.invoiceNumber || "",

  // Tipo de emisor
  emitterType: data.emitterType || EMITTER_TYPES.SUPPLIER,

  // Emisor (proveedor, comercial o cliente en caso de abono)
  emitterId: data.emitterId || "",
  emitterName: data.emitterName || "",
  emitterTaxId: data.emitterTaxId || "",
  emitterAddress: data.emitterAddress || "",
  emitterEmail: data.emitterEmail || "",

  // Receptor (EPC)
  receiverName: data.receiverName || "EPC Development & Management, S.L.",
  receiverTaxId: data.receiverTaxId || "B26623850",
  receiverAddress:
    data.receiverAddress || "C/ Juan de Austria 13, Cox, Alicante",

  // Importes
  baseAmount: data.baseAmount || 0,
  taxRate: data.taxRate || 21,
  taxAmount: data.taxAmount || 0,
  total: data.total || 0,

  // Líneas (para abonos, mismas líneas que la factura original)
  lines: data.lines || [],

  // Proyectos asociados
  projects: data.projects || [],

  // Porcentaje de asignación
  allocationPercentage: data.allocationPercentage || "",

  // Fechas
  issueDate: data.issueDate || new Date().toISOString(),
  dueDate: data.dueDate || "",

  // Forma de pago
  paymentMethod: data.paymentMethod || PAYMENT_METHODS.TRANSFER,
  iban: data.iban || "",

  // Estado - Por defecto SIN PAGAR
  status: data.status || PURCHASE_INVOICE_STATUS.UNPAID,

  // Estado de subida al Drive
  uploadedToDrive: data.uploadedToDrive || false,
  uploadedToDriveAt: data.uploadedToDriveAt || null,

  // Archivos adjuntos (misma estructura que empresas)
  files: data.files || [],

  // Referencia a la factura de venta original (si es abono)
  relatedInvoiceId: data.relatedInvoiceId || null,
  relatedInvoiceNumber: data.relatedInvoiceNumber || null,

  // Metadata
  notes: data.notes || "",
  paidAt: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: "",
  isActive: true,
});
